<template>
  <div class="modal-window uts019">
    <header class="modal-header">
      <div class="tit">정보차단벽 예외 처리</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="info-txt">정보차단벽 예외처리 할 보드를 선택하세요.</div>

      <div class="tab_ty3" id="tabsTy5">
        <ul class="tab-menu">
          <li
            v-for="(tab, index) in tabsTy5"
            v-bind:class="{ active: currentTab5 === index }"
            :key="index"
          >
            <input type="radio" name="tab1" :id="'tab1' + index" /><label
              :for="'tab1' + index"
              v-on:click="currentTab5Click(index)"
              >{{ tab }}</label
            >
          </li>
        </ul>
        <div class="tab-content">
          <!-- 과제/프라이빗 -->
          <div v-show="currentTab5 == 0">
            <div class="height">
                <div class="dropdown ty2 relative wide">
                  <div class="search_ty2" style="float: right;width: 100%;">
                    <input
                        type="text"
                        style="width: 96%;"
                        required
                        placeholder="공간명으로 검색하세요."
                        v-model="searchKey"
                        @keyup.enter="getSearchGroupList"
                    />
                    <button
                        type="button"
                        class="input-txt"
                        @click="getSearchGroupList"
                    >
                    {{$i18nUtil.trans("search.039","검색")}}
                    </button>
                    </div>
                </div>
                <div class="error" v-if="error_0_1">
                    공간명을 입력해주세요.
                </div>
            </div>
            <div class="height">
              <div class="dropdown ty2 relative wide">
                  <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" class="disabled">
                            {{
                              selectedGroupInfo.groupId == undefined
                                ? "공간 선택"
                                : searchGroupName
                            }}
                            <!-- addLinkProjectName -->
                          </v-btn>
                      </template>
                      <div class="dropdown-list">
                          <div class="scroll">
                              <div class="dropdown-list-item"
                                v-if="groupList.length == 0"
                              >
                                <div class="no-data">{{$i18nUtil.trans("search.034","등록된 공간이 없습니다.")}}</div>
                              </div>
                              <div
                                v-else 
                                class="dropdown-list-item"
                                v-for="(groupItem, projectIndex) in groupList"
                                :value="groupItem"
                                :key="groupItem.groupId + `test` + projectIndex"
                                @click="changeProject(groupItem, $event)"
                              >
                                <div class="tit">
                                  <button
                                    type="button"
                                    :class="{
                                      active:
                                        selectedGroupInfo.groupId == groupItem.groupId,
                                    }"
                                  >
                                    {{ groupItem.groupName }}
                                  </button>
                                </div>
                              </div>
                          </div>
                      </div>
                  </v-menu>
              </div>
              <div class="error" v-if="error_0_1">
                공간명을 입력해주세요.
              </div>
            </div>
            <div class="height">
              <div
                class="dropdown ty2 relative wide"
                :class="{
                  disabled: selectedGroupInfo.groupId == undefined,
                }"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on">
                      {{
                        addLinkProjectCategoryMid == ""
                          ? $i18nUtil.trans("entity.category.depth2.search.select","과정 선택")
                          : addLinkProjectCategoryName
                      }}</v-btn
                    >
                  </template>
                  <div class="dropdown-list">
                    <div class="scroll">
                      <div
                        class="dropdown-list-item"
                        style="padding-top: 30px"
                        v-if="groupFolderList.length == 0"
                      >
                        <div class="no-data">등록된 과정이 없습니다.</div>
                      </div>
                      <div
                        v-else
                        class="dropdown-list-item"
                        v-for="(item, groupFolderIndex) in groupFolderList"
                        :key="'grouptFolder' + groupFolderIndex"
                        @click="changeProjectFolder(item, 'dtProjectFolder')"
                      >
                        <div class="tit">
                          <button
                            type="button"
                            :class="{
                              active:
                                addLinkProjectCategoryMid == item.categoryMid,
                            }"
                          >
                            {{ item.categoryName }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-menu>
              </div>
              <div class="error" v-if="error_0_3">
                {{$i18nUtil.trans("UB012")}}
              </div>
            </div>

            <div class="height">
              <div
                class="dropdown ty2 relative wide"
                :class="{ disabled: addLinkProjectId == '' }"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on">{{
                      groupBoard.paperId == undefined
                        ? $i18nUtil.trans("message.TodoLinkedModal.004","업무 보드 선택")
                        : groupBoard.paperTitle
                    }}</v-btn>
                  </template>
                  <div class="dropdown-list">
                    <div class="scroll">
                      <div
                        class="dropdown-list-item"
                        style="padding-top: 30px"
                        v-if="groupBoardList.length == 0"
                      >
                        <div class="no-data">{{ $i18nUtil.trans("search.035","등록된 보드가 없습니다.") }}</div>
                      </div>
                      <div
                        class="dropdown-list-item"
                        v-for="(item, groupBoardIndex) in groupBoardList"
                        :key="'groupBoardIndex_' + groupBoardIndex"
                        @click="setGroupBoard(item)"
                      >
                        <div class="tit">
                          <button
                            type="button"
                            :class="{
                              active: item.paperId == groupBoard.paperId,
                            }"
                          >
                            {{ item.paperTitle }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-menu>
              </div>
              <div class="error" v-if="error_0_2">
                {{$i18nUtil.trans("UB025")}}
              </div>
            </div>
          </div> 
          <!-- 회의/협의 -->
          <div v-show="currentTab5 == 1">
            <div class="height">
                <div class="dropdown ty2 relative wide">
                  <div class="search_ty2" style="float: right;width: 100%;">
                    <input
                        type="text"
                        style="width: 96%;"
                        required
                        placeholder="카테고리명으로 검색하세요."
                        v-model="searchKey2"
                        @keyup.enter="getCfrcCategoryList"
                    />
                    <button
                        type="button"
                        class="input-txt"
                        @click="getCfrcCategoryList"
                    >
                    {{$i18nUtil.trans("search.039","검색")}}
                    </button>
                    </div>
                </div>
                <div class="error" v-if="error_0_2">
                    카테고리를 입력해주세요.
                </div>
            </div>
            <div class="height">
              <div class="dropdown ty2 relative wide">
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" class="disabled">
                          {{
                            cfrcCategory.categoryMid == undefined
                              ? $i18nUtil.trans("message.TodoLinkedModal.005","카테고리 선택")
                              : cfrcSearch
                          }}
                        </v-btn>
                    </template>
                    <div class="dropdown-list">
                        <div class="scroll">
                            <div class="dropdown-list-item"
                              v-if="cfrcCategoryList.length == 0"
                            >
                              <div class="no-data">{{ $i18nUtil.trans("message.TodoLinkedModal.002","등록된 카테고리가 없습니다.") }}</div>
                            </div>
                            <div
                              v-else 
                              class="dropdown-list-item"
                              v-for="(cfrcCategoryItem, cfrcCategoryIndex) in cfrcCategoryList"
                              :value="cfrcCategoryItem"
                              :key="'cfrcCategoryIndex_' + cfrcCategoryIndex"
                              @click="setCfrcCategory(cfrcCategoryItem)"
                            >
                              <div class="tit">
                                <button
                                  type="button"
                                  :class="{
                                    active:
                                      cfrcCategory.categoryMid == cfrcCategoryItem.categoryMid,
                                  }"
                                >
                                  {{ cfrcCategoryItem.categoryName }}
                                </button>
                              </div>
                            </div>
                        </div>
                    </div>
                </v-menu>
              </div>
              <div class="error" v-if="error_3_1">
                {{$i18nUtil.trans("UB005")}}
              </div>
            </div>
            <div class="height">
              <div
                class="dropdown ty2 relative wide"
                :class="{ disabled: cfrcCategory.categoryMid == undefined }"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on">{{
                      cfrsBoard.paperId == undefined
                        ? $i18nUtil.trans("message.TodoLinkedModal.004","업무 보드 선택")
                        : cfrsBoard.paperTitle
                    }}</v-btn>
                  </template>
                  <div class="dropdown-list">
                    <div class="scroll">
                      <div
                        class="dropdown-list-item"
                        style="padding-top: 30px"
                        v-if="cfrsBoardList.length == 0"
                      >
                        <div class="no-data">{{ $i18nUtil.trans("search.035","등록된 보드가 없습니다.") }}</div>
                      </div>
                      <div
                        v-else
                        class="dropdown-list-item"
                        v-for="(item, cfrsBoardIndex) in cfrsBoardList"
                        :key="'cfrsBoardIndex_' + cfrsBoardIndex"
                      >
                        <div class="tit">
                          <button
                            type="button"
                            @click="setCfrsBoard(item)"
                            :class="{
                              active: item.paperId == cfrsBoard.paperId,
                            }"
                          >
                            {{ item.paperTitle }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-menu>
              </div>
              <div class="error" v-if="error_3_2">
                {{$i18nUtil.trans("UB025")}}
              </div>
            </div>
          </div>
        </div>
        <footer class="modal-footer" style="margin-top:25px;" >
          <button type="button" class="btn_ty1" @click="submitCwPaper">추가</button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import axios from "axios";
import EventBus from "@/js/eventbus/eventBus";

export default {
  components: {
    Datepicker,
  },
  props: {
    //modalInfo.userInfo
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      /* tenantId */
      tenantId: localStorage.getItem("tenantId"),
      date: "2020.12.31",
      show: false,
      error: false,
      currentTab5: 0,
      tabsTy5: ["과제/프라이빗","회의/협의"],

      error_0_1: false,
      error_0_2: false,
      error_0_3: false,
      error_1_1: false,
      error_2_1_1: false,
      error_2_1_2: false,
      error_2_2_1: false,
      error_3_1: false,
      error_3_2: false,

      linkedGroupInfo: {},
      groupList: [],
      groupFolder: {},
      groupFolderList: [],
      groupBoard: {},
      groupBoardList: [],

      searchGroupName:"",
      isProjectShow: false,
      paperId: null,
      projectId: null,
      groupList: [], 
      selectedGroupInfo: {},
      addLinkProjectId: "",
      addLinkProjectGroupId: "",
      addLinkProjectCategoryMid: "",
      addLinkProjectCategoryName: "",
      /* 폴더 */
      groupFolderList: [],
      selectedProjectFolder: {},

      //회의/협의
      cfrcCategory: {},
      cfrcCategoryList: [],
      cfrcCategoryListFilter: [],
      cfrsBoard: {},
      cfrsBoardList: [],
      isCfrcCategoryListShow: false,
      cfrcSearch: null,

      //검색
      searchKey : "", // 과제(공간)검색.
      searchKey2: "", // 회의/협의 카테고리 검색. 
    };
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions("modals", ["showModal"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION", "COWORK_REST_SIMPLE_ACTION"]),
    /* 리스트 조회 */
    getSearchGroupList() {
        let obj = this;
        let reqData = {};
        reqData.params = {
            searchKey: obj.searchKey
        };
        reqData.url = "/api/cogroup/project/getAllProjectListWithSearchKey";
        reqData.method = "post";

        //프로그레스바 시작
        this.showLoadingbar();
        obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
            //프로그레스바 종료
            this.hideLoadingbar();
            if (res.errorCode) {
                console.log(res.errorCode);
                obj.authorize = res.errorCode;
            } else {
                obj.groupList = res.result;
                obj.selectedGroupInfo = {}; 
            }
        })
        .catch((err) => {
            console.log("axios err => ", err);
        }); 
    },
    /* 과제선택 -> 과정 리스트 조회 */
    changeProject(groupInfo) {
      let obj = this;
      obj.isProjectShow = false;
      // 같은 선택 시 리턴
      if(obj.selectedGroupInfo == groupInfo) {
        return;
      }
      obj.selectedGroupInfo = groupInfo;
      if (
        groupInfo != null &&
        groupInfo.groupId != null &&
        groupInfo.groupId != undefined
      ) {
        obj.searchGroupName = groupInfo.groupName;

        let reqData = {};
        reqData.params = {
          categoryMid: null,
          groupId: groupInfo.groupId,
          type: "PROJECT",
        };
        reqData.url = "/api/copaper/category/getCategoryItemList";
        reqData.method = "post";

        //프로그레스바 시작
        this.showLoadingbar();
        obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
            //프로그레스바 종료
            this.hideLoadingbar();
            if (res.errorCode != null && res.errorCode != undefined) {
              alert(res.errorCode);
              return;
            }
            obj.error_0_1 = false;
            obj.error_0_2 = false;
            obj.error_0_3 = false;
            obj.addLinkProjectId = "";
            obj.addLinkProjectCategoryMid = "";
            obj.addLinkProjectCategoryName = "";
            obj.groupBoard = {};
            obj.groupFolderList = res.result;
        })
        .catch((err) => {
            console.log("axios err => ", err);
        }); 
      } else {
        //obj.moreClose("dtProjectFolder");
        obj.addLinkProjectId = "";
        obj.addLinkProjectGroupId = "";
        obj.addLinkProjectCategoryMid = "";
        obj.addLinkProjectCategoryName = "";
        obj.groupFolderList = [];
      }
    },
    /* 과정선택 -> 보드 리스트 조회 ( SECRET ) */
    changeProjectFolder(projectFolderInfo, dtId) {
      console.log(projectFolderInfo);
      if (projectFolderInfo == null) {
        this.addLinkProjectId = "";
        this.addLinkProjectGroupId = "";
        this.addLinkProjectCategoryMid = "";
        this.addLinkProjectCategoryName = "";
      } else {
        this.addLinkProjectId = projectFolderInfo.projectId;
        this.addLinkProjectGroupId = projectFolderInfo.groupId;
        this.addLinkProjectCategoryMid = projectFolderInfo.categoryMid;
        this.addLinkProjectCategoryName = projectFolderInfo.categoryName;
        this.groupBoard = {};
        this.groupBoardList = [];
        this.error_0_1 = false;
        this.error_0_2 = false;
        this.error_0_3 = false;
 
        this.getProjectBoardList();
      }
      // this.moreClose(dtId);
    },
    getProjectBoardList() {
      let obj = this;
      let reqData = {};
      reqData.params = {
        categoryMid: this.addLinkProjectCategoryMid,
        section: "PROJECT", //'IDEATION'
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/paper/getSecretPaperListByCategoryMid";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          this.groupBoardList = res.result;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    // 회의&협의 S
    getCfrcCategoryList() { 
      let obj = this;
      let reqData = {};
      reqData.params = {
          searchKey: obj.searchKey2
      };
      reqData.url = "/api/copaper/cooperation/getCfrcCategoryListWithSearchKey";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
      .COWORK_REST_SIMPLE_ACTION(reqData)
      .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
              console.log(res.errorCode); 
          } else {
              obj.cfrcCategoryList= res.result; 
          }
      })
      .catch((err) => {
          console.log("axios err => ", err);
      });
    },
    getCfrcPaperList(param) {
      let obj = this;
      let reqData = {
        url: "/api/copaper/paper/getSecretPaperListByCategoryMid",
        method: "post",
        params: { categoryMid: param.categoryMid },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          obj.cfrsBoardList = res.result;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    // 회의&협의 E
    setGroupBoard(param) {
      this.error_0_2 = false;
      this.groupBoard = {
        paperTitle: param.paperTitle,
        paperId: param.paperId,
      };
      // document.getElementById("groupBoardListDt").classList.toggle("active");
    },
    setCfrcCategory(param) {
      this.cfrcCategory = param;
      this.cfrcSearch = param.categoryName;
      this.isCfrcCategoryListShow = false;
      this.error_3_1 = false;
      this.error_3_2 = false;
      this.cfrsBoard = "";
      this.getCfrcPaperList(param);
    },
    setCfrsBoard(param) {
      this.cfrsBoard = param;
      this.error_3_2 = false;
    },
    // 탭 이동시 주요 파라미터 제거
    paramNull() {
      this.searchGroupName = "";
      this.groupFolderList = [];
      this.groupFolderList = [];
      this.groupBoardList = [];
      this.cfrsBoardList = [];
      this.cfrcCategory = {};
      this.cfrcSearch = "";
      this.cfrsBoard = "";
      this.groupBoard = {};
      this.addLinkProjectId = "";
      this.addLinkProjectGroupId = "";
      this.addLinkProjectCategoryMid = "";
      this.addLinkProjectCategoryName = "";
      this.error_0_1 = false;
      this.error_0_2 = false;
      this.error_0_3 = false;
      this.error_1_1 = false;
      this.error_2_1_1 = false;
      this.error_2_1_2 = false;
      this.error_2_2_1 = false;
      this.error_3_1 = false;
      this.error_3_2 = false;
    },
    currentTab5Click(index) {
      this.currentTab5 = index;
      this.paramNull();
    },
    submitCwPaper() {
      let paperId = null;
      if(this.currentTab5 == 0){
        if (this.selectedGroupInfo.groupId != undefined) { 
          if (
            this.addLinkProjectCategoryName == null ||
            this.addLinkProjectCategoryName == ""
          ) { 
            this.error_0_3 = true;
          } else if (this.groupBoard.paperId == undefined) {
            this.error_0_2 = true;
          } else{
            paperId = this.groupBoard.paperId;
          }
        } else {
          this.error_0_1 = true;
        }
      }else if(this.currentTab5 == 1){
        if (this.cfrcCategory.categoryMid == undefined) {
          this.error_3_1 = true;
        } else {
          if (this.cfrsBoard.paperId != undefined) {
            paperId = this.cfrsBoard.paperId
          } else { 
            this.error_3_2 = true;
          }
        }
      }
 
      if(paperId != null && paperId != ""){
        let linkParam = {paperId : paperId};
        this.$emit("registCwExceptPaper", linkParam);
        this.$emit("close");
      }
    },
  },
};
</script>
<style>
.uts004.sec .v-menu {
  margin-left: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/modal/CwExceptSetting.vue